var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-footer',{staticClass:"d-flex justify-space-around scrollBg"},[_c('i',{domProps:{"textContent":_vm._s('Valy (v. ' + _vm.version + ') Copyright ©'+new Date().getFullYear()+' LoesusPedagogia')}})])
}
var staticRenderFns = []

export { render, staticRenderFns }